import ax from '../axios'
import { IClassroom, IClassroomCurriculum, ID } from "../../constants";
import {API_URL} from "../index";

const CLASSROOM_URL = API_URL.EDUCATION_MODULE + '/classroom'

const getClassrooms = (query: string) => {
    return ax.get(`${CLASSROOM_URL}?${query}`)
}
const getStaffClassrooms = (query: string)  => {
    return ax.get(`${CLASSROOM_URL}/staff?${query}`)
}
const getClassroomById = (id: ID) => {
    return ax.get(`${CLASSROOM_URL}/${id}`)
}

const createClassroom = (classroom: IClassroom) => {
    delete classroom.id
    return ax.post(CLASSROOM_URL, classroom)
}

const updateClassroom = (classroom: IClassroom) => {
    const id = classroom.id
    delete classroom.id
    return ax.put(`${CLASSROOM_URL}/${id}`, classroom)
}

const patchClassroomCurriculum = (classroom: IClassroomCurriculum) => {
    return ax.patch(`${CLASSROOM_URL}/curriculum`, classroom)
}

const deleteClassroom = (classroomId: ID) => {
    return ax.delete(`${CLASSROOM_URL}/${classroomId}`)
}

export {
    getClassrooms,
    getClassroomById,
    createClassroom,
    updateClassroom,
    deleteClassroom,
    getStaffClassrooms,
    patchClassroomCurriculum
}
